"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.records.title': 'Your Onboarding Records',
    'onboarding.records.empty.title': 'No Onboarding Records Yet',
    'onboarding.records.empty.description': 'Start your first onboarding process to see records here.',
};
